(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Bannerletmedeck"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(raiz) {
      if (raiz.dataset.cmxIniciado === '1') return;
      raiz.dataset.cmxIniciado = '1';

      var pista = raiz.querySelector('[data-cmx-pista]');
      var slides = raiz.querySelectorAll('[data-cmx-slide]');
      var puntos = raiz.querySelectorAll('[data-cmx-punto]');
      var prev = raiz.querySelector('[data-cmx-prev]');
      var next = raiz.querySelector('[data-cmx-next]');
      var viewport = raiz.querySelector('[data-cmx-viewport]');
      var total = slides.length;

      if (!pista || total <= 1) {
        if (prev) prev.style.setProperty('display', 'none', 'important');
        if (next) next.style.setProperty('display', 'none', 'important');
        var contenedorPuntos = raiz.querySelector('[data-cmx-puntos]');
        if (contenedorPuntos) contenedorPuntos.style.setProperty('display', 'none', 'important');
        return;
      }

      var indice = 0;
      var efecto = raiz.dataset.efecto || 'deslizar';
      var autoplay = raiz.dataset.autoplay === 'true';
      var intervalo = parseInt(raiz.dataset.intervalo, 10) || 5000;
      var pausaHover = raiz.dataset.pausa === 'true';
      var temporizador = null;

      function pintar() {
        if (efecto === 'deslizar') {
          pista.style.setProperty('transform', 'translateX(' + (-indice * 100) + '%)', 'important');
        } else {
          for (var s = 0; s < slides.length; s++) {
            slides[s].classList.toggle('cmx-bnr__slide--activo', s === indice);
          }
        }
        for (var i = 0; i < puntos.length; i++) {
          var activo = i === indice;
          puntos[i].classList.toggle('cmx-bnr__punto--activo', activo);
          puntos[i].setAttribute('aria-current', activo ? 'true' : 'false');
        }
      }

      function ir(i) {
        indice = (i + total) % total;
        pintar();
        reiniciar();
      }

      function siguiente() { ir(indice + 1); }
      function anterior() { ir(indice - 1); }

      function arrancar() {
        if (autoplay && !temporizador) {
          temporizador = setInterval(siguiente, intervalo);
        }
      }

      function parar() {
        if (temporizador) {
          clearInterval(temporizador);
          temporizador = null;
        }
      }

      function reiniciar() {
        parar();
        arrancar();
      }

      if (next) next.addEventListener('click', siguiente);
      if (prev) prev.addEventListener('click', anterior);

      for (var p = 0; p < puntos.length; p++) {
        (function (idx) {
          puntos[idx].addEventListener('click', function () { ir(idx); });
        })(p);
      }

      if (pausaHover) {
        raiz.addEventListener('mouseenter', parar);
        raiz.addEventListener('mouseleave', arrancar);
      }

      var inicioX = null;
      var objetivo = viewport || pista;

      objetivo.addEventListener('touchstart', function (e) {
        inicioX = e.touches[0].clientX;
        parar();
      }, { passive: true });

      objetivo.addEventListener('touchend', function (e) {
        if (inicioX === null) return;
        var dx = e.changedTouches[0].clientX - inicioX;
        if (Math.abs(dx) > 40) {
          if (dx < 0) siguiente(); else anterior();
        } else {
          arrancar();
        }
        inicioX = null;
      }, { passive: true });

      raiz.cmxApi = { ir: ir, parar: parar, arrancar: arrancar, slides: slides };

      pintar();
      arrancar();
    }

    function iniciarTodos(ambito) {
      var raices = (ambito || document).querySelectorAll('[data-cmx-banner]');
      for (var i = 0; i < raices.length; i++) iniciar(raices[i]);
    }

    if (document.readyState !== 'loading') {
      iniciarTodos();
    } else {
      document.addEventListener('DOMContentLoaded', function () { iniciarTodos(); });
    }

    document.addEventListener('shopify:section:load', function (e) {
      iniciarTodos(e.target);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest('[data-cmx-slide]');
      if (!slide) return;
      var raiz = slide.closest('[data-cmx-banner]');
      if (!raiz || !raiz.cmxApi) return;
      var indice = Array.prototype.indexOf.call(raiz.cmxApi.slides, slide);
      if (indice >= 0) raiz.cmxApi.ir(indice);
      raiz.cmxApi.parar();
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      var slide = e.target.closest('[data-cmx-slide]');
      if (!slide) return;
      var raiz = slide.closest('[data-cmx-banner]');
      if (raiz && raiz.cmxApi) raiz.cmxApi.arrancar();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["CardSliderLmd"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function activarTab(tab) {
      var raiz = tab.closest('.cmx-ps');
      if (!raiz) return;
      var idx = tab.getAttribute('data-cmx-tab');
      var tabs = raiz.querySelectorAll('[data-cmx-tab]');
      for (var i = 0; i < tabs.length; i++) {
        var act = tabs[i] === tab;
        tabs[i].classList.toggle('cmx-ps__tab--activo', act);
        tabs[i].setAttribute('aria-selected', act ? 'true' : 'false');
      }
      var paneles = raiz.querySelectorAll('[data-cmx-panel]');
      for (var p = 0; p < paneles.length; p++) {
        paneles[p].classList.toggle('cmx-ps__panel--activo', paneles[p].getAttribute('data-cmx-panel') === idx);
      }
    }

    function ajustar(btn, delta) {
      var form = btn.closest('form');
      if (!form) return;
      var input = form.querySelector('[data-cmx-cantidad]');
      if (!input) return;
      var val = parseInt(input.value, 10);
      if (isNaN(val)) val = 1;
      val += delta;
      if (val < 1) val = 1;
      input.value = val;
    }

    function desplazar(btn, dir) {
      var vp = btn.closest('.cmx-ps__viewport');
      if (!vp) return;
      var pista = vp.querySelector('[data-cmx-pista]');
      if (!pista) return;
      var card = pista.querySelector('.cmx-ps__card');
      var estilo = window.getComputedStyle(pista);
      var gap = parseFloat(estilo.columnGap || estilo.gap) || 0;
      var paso = card ? (card.getBoundingClientRect().width + gap) : (pista.clientWidth * 0.8);
      pista.scrollBy({ left: dir * paso, behavior: 'smooth' });
    }

    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-cmx-tab]');
      if (tab) { activarTab(tab); return; }
      var mas = e.target.closest('[data-cmx-mas]');
      if (mas) { ajustar(mas, 1); return; }
      var menos = e.target.closest('[data-cmx-menos]');
      if (menos) { ajustar(menos, -1); return; }
      var next = e.target.closest('[data-cmx-next]');
      if (next) { desplazar(next, 1); return; }
      var prev = e.target.closest('[data-cmx-prev]');
      if (prev) { desplazar(prev, -1); return; }
    });

    document.addEventListener('shopify:block:select', function (e) {
      var tab = e.target.closest('[data-cmx-tab]');
      if (tab) activarTab(tab);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Letmedeckheader"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefijo = 'cmx-enc';

    function bloquearScroll(activo) {
      document.documentElement.style.overflow = activo ? 'hidden' : '';
      document.body.style.overflow = activo ? 'hidden' : '';
    }

    function cerrarCajon(cajon) {
      if (!cajon) return;
      cajon.classList.remove(prefijo + '__cajon--activo');
      cajon.setAttribute('aria-hidden', 'true');
      var overlay = cajon.parentElement.querySelector('.' + prefijo + '__overlay');
      if (overlay) overlay.classList.remove(prefijo + '__overlay--activo');
      var disparador = cajon.parentElement.querySelector('[data-cmx-abrir]');
      if (disparador) disparador.setAttribute('aria-expanded', 'false');
      bloquearScroll(false);
    }

    function abrirCajon(encabezado) {
      var cajon = encabezado.querySelector('[data-cmx-cajon]');
      var overlay = encabezado.querySelector('.' + prefijo + '__overlay');
      var disparador = encabezado.querySelector('[data-cmx-abrir]');
      if (!cajon) return;
      cajon.classList.add(prefijo + '__cajon--activo');
      cajon.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add(prefijo + '__overlay--activo');
      if (disparador) disparador.setAttribute('aria-expanded', 'true');
      bloquearScroll(true);
    }

    if (!window.__cmxEncInit) {
      window.__cmxEncInit = true;

    document.addEventListener('click', function (evento) {
      var abrir = evento.target.closest('[data-cmx-abrir]');
      if (abrir) {
        var encAbrir = abrir.closest('.' + prefijo);
        if (encAbrir) abrirCajon(encAbrir);
        return;
      }

      var cerrar = evento.target.closest('[data-cmx-cerrar]');
      if (cerrar) {
        cerrarCajon(cerrar.closest('[data-cmx-cajon]'));
        return;
      }

      var overlay = evento.target.closest('[data-cmx-overlay]');
      if (overlay) {
        cerrarCajon(overlay.parentElement.querySelector('[data-cmx-cajon]'));
        return;
      }

      var acordeon = evento.target.closest('[data-cmx-acordeon]');
      var acordeonEnlace = evento.target.closest('[data-cmx-acordeon-enlace]');
      var acordeonFila = evento.target.closest('[data-cmx-acordeon-fila]');
      if (acordeon || acordeonEnlace || acordeonFila) {
        evento.preventDefault();
        var disparadorAc = acordeon || acordeonEnlace || acordeonFila;
        var elemento = disparadorAc.closest('.' + prefijo + '__cajon-elemento');
        var boton = elemento ? elemento.querySelector('[data-cmx-acordeon]') : null;
        var submenu = elemento ? elemento.querySelector('.' + prefijo + '__submenu') : null;
        if (!submenu && boton) {
          var fila = boton.closest('.' + prefijo + '__cajon-fila');
          submenu = fila ? fila.nextElementSibling : null;
        }
        var refAria = boton || disparadorAc;
        var abierto = refAria.getAttribute('aria-expanded') === 'true';
        if (boton) boton.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        if (submenu) {
          if (abierto) {
            submenu.setAttribute('hidden', '');
          } else {
            submenu.removeAttribute('hidden');
          }
        }
        return;
      }

      var botonBuscador = evento.target.closest('[data-cmx-buscador-boton]');
      if (botonBuscador) {
        var formBuscador = botonBuscador.closest('[data-cmx-buscador]');
        if (!formBuscador) return;
        var entrada = formBuscador.querySelector('[data-cmx-buscador-input]');
        var estaAbierto = formBuscador.classList.contains(prefijo + '__buscador--abierto');
        if (!estaAbierto) {
          formBuscador.classList.add(prefijo + '__buscador--abierto');
          botonBuscador.setAttribute('aria-expanded', 'true');
          if (entrada) entrada.focus();
        } else if (entrada && entrada.value.trim() !== '') {
          formBuscador.submit();
        } else {
          formBuscador.classList.remove(prefijo + '__buscador--abierto');
          botonBuscador.setAttribute('aria-expanded', 'false');
        }
        return;
      }

      var abrirBuscadorMovil = evento.target.closest('[data-cmx-buscador-movil-abrir]');
      if (abrirBuscadorMovil) {
        var encMovil = abrirBuscadorMovil.closest('.' + prefijo);
        if (encMovil) {
          encMovil.classList.add(prefijo + '--buscar-abierto');
          var panelMovil = encMovil.querySelector('[data-cmx-buscador-movil]');
          if (panelMovil) {
            panelMovil.setAttribute('aria-hidden', 'false');
            var entradaMovil = panelMovil.querySelector('[data-cmx-buscador-movil-input]');
            if (entradaMovil) entradaMovil.focus();
          }
        }
        return;
      }

      var cerrarBuscadorMovil = evento.target.closest('[data-cmx-buscador-movil-cerrar]');
      if (cerrarBuscadorMovil) {
        var encMovilCerrar = cerrarBuscadorMovil.closest('.' + prefijo);
        if (encMovilCerrar) {
          encMovilCerrar.classList.remove(prefijo + '--buscar-abierto');
          var panelMovilCerrar = encMovilCerrar.querySelector('[data-cmx-buscador-movil]');
          if (panelMovilCerrar) panelMovilCerrar.setAttribute('aria-hidden', 'true');
        }
        return;
      }

      if (!evento.target.closest('[data-cmx-buscador]')) {
        var abiertos = document.querySelectorAll('.' + prefijo + '__buscador--abierto');
        abiertos.forEach(function (b) {
          b.classList.remove(prefijo + '__buscador--abierto');
          var bt = b.querySelector('[data-cmx-buscador-boton]');
          if (bt) bt.setAttribute('aria-expanded', 'false');
        });
      }
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key !== 'Escape') return;
      var cajones = document.querySelectorAll('.' + prefijo + '__cajon--activo');
      cajones.forEach(function (cajon) {
        cerrarCajon(cajon);
      });
      var buscadores = document.querySelectorAll('.' + prefijo + '__buscador--abierto');
      buscadores.forEach(function (b) {
        b.classList.remove(prefijo + '__buscador--abierto');
        var bt = b.querySelector('[data-cmx-buscador-boton]');
        if (bt) bt.setAttribute('aria-expanded', 'false');
      });
      var buscadoresMovil = document.querySelectorAll('.' + prefijo + '--buscar-abierto');
      buscadoresMovil.forEach(function (bm) {
        bm.classList.remove(prefijo + '--buscar-abierto');
        var panel = bm.querySelector('[data-cmx-buscador-movil]');
        if (panel) panel.setAttribute('aria-hidden', 'true');
      });
    });

    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Preventasfrontpage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick(el) {
      var fecha = el.getAttribute('data-cmx-fecha');
      if (!fecha) return true;
      var objetivo = new Date(fecha.replace(' ', 'T')).getTime();
      if (isNaN(objetivo)) return true;
      var diff = objetivo - Date.now();
      if (diff <= 0) {
        el.classList.add('cmx-pv__contador--fin');
        return true;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var set = function (sel, v) {
        var n = el.querySelector(sel);
        if (n) n.textContent = pad(v);
      };
      set('[data-cmx-dias]', d);
      set('[data-cmx-hrs]', h);
      set('[data-cmx-min]', m);
      set('[data-cmx-seg]', s);
      return false;
    }

    function iniciarContadores(raiz) {
      var els = (raiz || document).querySelectorAll('[data-cmx-contador]');
      els.forEach(function (el) {
        if (el._cmxInt) clearInterval(el._cmxInt);
        var listo = tick(el);
        if (listo) return;
        el._cmxInt = setInterval(function () {
          if (tick(el)) clearInterval(el._cmxInt);
        }, 1000);
      });
    }

    function iniciarSliders() {
      var secciones = document.querySelectorAll('[data-cmx-pv-slider]');
      secciones.forEach(function (sec) {
        var slides = sec.querySelectorAll('[data-cmx-slide]');
        var cuenta = sec.querySelector('[data-cmx-cuenta]');
        var btnAnt = sec.querySelector('[data-cmx-ant]');
        var btnSig = sec.querySelector('[data-cmx-sig]');
        var total = slides.length;
        if (total < 2) return;
        var actual = 0;

        function ir(idx) {
          slides[actual].classList.remove('cmx-pv__slide--activo');
          actual = (idx + total) % total;
          slides[actual].classList.add('cmx-pv__slide--activo');
          if (cuenta) cuenta.textContent = (actual + 1) + ' / ' + total;
          iniciarContadores(slides[actual]);
        }

        if (btnAnt) btnAnt.addEventListener('click', function () { ir(actual - 1); });
        if (btnSig) btnSig.addEventListener('click', function () { ir(actual + 1); });
      });
    }

    iniciarContadores();
    iniciarSliders();
    document.addEventListener('shopify:section:load', function () {
      iniciarContadores();
      iniciarSliders();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefijo = 'cmx-enc';

    function bloquearScroll(activo) {
      document.documentElement.style.overflow = activo ? 'hidden' : '';
      document.body.style.overflow = activo ? 'hidden' : '';
    }

    function cerrarCajon(cajon) {
      if (!cajon) return;
      cajon.classList.remove(prefijo + '__cajon--activo');
      cajon.setAttribute('aria-hidden', 'true');
      var overlay = cajon.parentElement.querySelector('.' + prefijo + '__overlay');
      if (overlay) overlay.classList.remove(prefijo + '__overlay--activo');
      var disparador = cajon.parentElement.querySelector('[data-cmx-abrir]');
      if (disparador) disparador.setAttribute('aria-expanded', 'false');
      bloquearScroll(false);
    }

    function abrirCajon(encabezado) {
      var cajon = encabezado.querySelector('[data-cmx-cajon]');
      var overlay = encabezado.querySelector('.' + prefijo + '__overlay');
      var disparador = encabezado.querySelector('[data-cmx-abrir]');
      if (!cajon) return;
      cajon.classList.add(prefijo + '__cajon--activo');
      cajon.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add(prefijo + '__overlay--activo');
      if (disparador) disparador.setAttribute('aria-expanded', 'true');
      bloquearScroll(true);
    }

    document.addEventListener('click', function (evento) {
      var abrir = evento.target.closest('[data-cmx-abrir]');
      if (abrir) {
        var encAbrir = abrir.closest('.' + prefijo);
        if (encAbrir) abrirCajon(encAbrir);
        return;
      }

      var cerrar = evento.target.closest('[data-cmx-cerrar]');
      if (cerrar) {
        cerrarCajon(cerrar.closest('[data-cmx-cajon]'));
        return;
      }

      var overlay = evento.target.closest('[data-cmx-overlay]');
      if (overlay) {
        cerrarCajon(overlay.parentElement.querySelector('[data-cmx-cajon]'));
        return;
      }

      var acordeon = evento.target.closest('[data-cmx-acordeon]');
      if (acordeon) {
        evento.preventDefault();
        var abierto = acordeon.getAttribute('aria-expanded') === 'true';
        var elemento = acordeon.closest('.' + prefijo + '__cajon-elemento');
        var submenu = elemento ? elemento.querySelector('.' + prefijo + '__submenu') : null;
        if (!submenu) {
          var fila = acordeon.closest('.' + prefijo + '__cajon-fila');
          submenu = fila ? fila.nextElementSibling : null;
        }
        acordeon.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        if (submenu) {
          if (abierto) {
            submenu.setAttribute('hidden', '');
          } else {
            submenu.removeAttribute('hidden');
          }
        }
        return;
      }

      var botonBuscador = evento.target.closest('[data-cmx-buscador-boton]');
      if (botonBuscador) {
        var formBuscador = botonBuscador.closest('[data-cmx-buscador]');
        if (!formBuscador) return;
        var entrada = formBuscador.querySelector('[data-cmx-buscador-input]');
        var estaAbierto = formBuscador.classList.contains(prefijo + '__buscador--abierto');
        if (!estaAbierto) {
          formBuscador.classList.add(prefijo + '__buscador--abierto');
          botonBuscador.setAttribute('aria-expanded', 'true');
          if (entrada) entrada.focus();
        } else if (entrada && entrada.value.trim() !== '') {
          formBuscador.submit();
        } else {
          formBuscador.classList.remove(prefijo + '__buscador--abierto');
          botonBuscador.setAttribute('aria-expanded', 'false');
        }
        return;
      }

      var abrirBuscadorMovil = evento.target.closest('[data-cmx-buscador-movil-abrir]');
      if (abrirBuscadorMovil) {
        var encMovil = abrirBuscadorMovil.closest('.' + prefijo);
        if (encMovil) {
          encMovil.classList.add(prefijo + '--buscar-abierto');
          var panelMovil = encMovil.querySelector('[data-cmx-buscador-movil]');
          if (panelMovil) {
            panelMovil.setAttribute('aria-hidden', 'false');
            var entradaMovil = panelMovil.querySelector('[data-cmx-buscador-movil-input]');
            if (entradaMovil) entradaMovil.focus();
          }
        }
        return;
      }

      var cerrarBuscadorMovil = evento.target.closest('[data-cmx-buscador-movil-cerrar]');
      if (cerrarBuscadorMovil) {
        var encMovilCerrar = cerrarBuscadorMovil.closest('.' + prefijo);
        if (encMovilCerrar) {
          encMovilCerrar.classList.remove(prefijo + '--buscar-abierto');
          var panelMovilCerrar = encMovilCerrar.querySelector('[data-cmx-buscador-movil]');
          if (panelMovilCerrar) panelMovilCerrar.setAttribute('aria-hidden', 'true');
        }
        return;
      }

      if (!evento.target.closest('[data-cmx-buscador]')) {
        var abiertos = document.querySelectorAll('.' + prefijo + '__buscador--abierto');
        abiertos.forEach(function (b) {
          b.classList.remove(prefijo + '__buscador--abierto');
          var bt = b.querySelector('[data-cmx-buscador-boton]');
          if (bt) bt.setAttribute('aria-expanded', 'false');
        });
      }
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key !== 'Escape') return;
      var cajones = document.querySelectorAll('.' + prefijo + '__cajon--activo');
      cajones.forEach(function (cajon) {
        cerrarCajon(cajon);
      });
      var buscadores = document.querySelectorAll('.' + prefijo + '__buscador--abierto');
      buscadores.forEach(function (b) {
        b.classList.remove(prefijo + '__buscador--abierto');
        var bt = b.querySelector('[data-cmx-buscador-boton]');
        if (bt) bt.setAttribute('aria-expanded', 'false');
      });
      var buscadoresMovil = document.querySelectorAll('.' + prefijo + '--buscar-abierto');
      buscadoresMovil.forEach(function (bm) {
        bm.classList.remove(prefijo + '--buscar-abierto');
        var panel = bm.querySelector('[data-cmx-buscador-movil]');
        if (panel) panel.setAttribute('aria-hidden', 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lmdProductorelacionado"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!customElements.get('cmx-recomendaciones')) {
      customElements.define('cmx-recomendaciones', class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.cmxCargado === 'true') return;
          var url = this.dataset.cmxRecUrl;
          if (!url) return;
          var self = this;
          var observador = new IntersectionObserver(function (entradas, obs) {
            if (!entradas[0].isIntersecting) return;
            obs.unobserve(self);
            self.dataset.cmxCargado = 'true';
            fetch(url)
              .then(function (r) { return r.text(); })
              .then(function (texto) {
                var cont = document.createElement('div');
                cont.innerHTML = texto;
                var nuevo = cont.querySelector('cmx-recomendaciones');
                if (nuevo && nuevo.innerHTML.trim().length) {
                  self.innerHTML = nuevo.innerHTML;
                } else {
                  var raiz = self.closest('.cmx-rec');
                  if (raiz) raiz.style.display = 'none';
                }
              })
              .catch(function () {});
          }, { rootMargin: '0px 0px 400px 0px' });
          observador.observe(this);
        }
      });
    }

    function ajustar(btn, delta) {
      var form = btn.closest('form');
      if (!form) return;
      var input = form.querySelector('[data-cmx-rec-cantidad]');
      if (!input) return;
      var val = parseInt(input.value, 10);
      if (isNaN(val)) val = 1;
      val += delta;
      if (val < 1) val = 1;
      input.value = val;
    }

    function desplazar(btn, dir) {
      var vp = btn.closest('.cmx-rec__viewport');
      if (!vp) return;
      var pista = vp.querySelector('[data-cmx-rec-pista]');
      if (!pista) return;
      var card = pista.querySelector('.cmx-rec__card');
      var estilo = window.getComputedStyle(pista);
      var gap = parseFloat(estilo.columnGap || estilo.gap) || 0;
      var paso = card ? (card.getBoundingClientRect().width + gap) : (pista.clientWidth * 0.8);
      pista.scrollBy({ left: dir * paso, behavior: 'smooth' });
    }

    if (!window.__cmxRecClickInit) {
      window.__cmxRecClickInit = true;
      document.addEventListener('click', function (e) {
        var mas = e.target.closest('[data-cmx-rec-mas]');
        if (mas) { ajustar(mas, 1); return; }
        var menos = e.target.closest('[data-cmx-rec-menos]');
        if (menos) { ajustar(menos, -1); return; }
        var next = e.target.closest('[data-cmx-rec-next]');
        if (next) { desplazar(next, 1); return; }
        var prev = e.target.closest('[data-cmx-rec-prev]');
        if (prev) { desplazar(prev, -1); return; }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (function () {
    function ajustar(btn, delta) {
      var form = btn.closest('form');
      if (!form) return;
      var input = form.querySelector('[data-cmx-col-cantidad]');
      if (!input) return;
      var val = parseInt(input.value, 10);
      if (isNaN(val)) val = 1;
      val += delta;
      if (val < 1) val = 1;
      input.value = val;
    }

    if (!window.__cmxColInit) {
      window.__cmxColInit = true;
      document.addEventListener('click', function (e) {
        var mas = e.target.closest('[data-cmx-col-mas]');
        if (mas) { ajustar(mas, 1); return; }
        var menos = e.target.closest('[data-cmx-col-menos]');
        if (menos) { ajustar(menos, -1); return; }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefijo = 'cmx-pp';

    function obtenerVariantes(seccion) {
      var nodo = seccion.querySelector('[data-cmx-variantes]');
      if (!nodo) return [];
      try {
        return JSON.parse(nodo.textContent);
      } catch (e) {
        return [];
      }
    }

    function seleccionActual(seccion) {
      var grupos = seccion.querySelectorAll('[data-cmx-opcion-grupo]');
      var valores = [];
      grupos.forEach(function (grupo) {
        var activo = grupo.querySelector('.cmx-pp__valor--activo');
        valores.push(activo ? activo.getAttribute('data-cmx-valor-nombre') : null);
      });
      return valores;
    }

    function buscarVariante(variantes, seleccion) {
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i];
        var coincide = true;
        for (var j = 0; j < seleccion.length; j++) {
          if (seleccion[j] !== v.opciones[j]) {
            coincide = false;
            break;
          }
        }
        if (coincide) return v;
      }
      return null;
    }

    function actualizar(seccion) {
      var variantes = obtenerVariantes(seccion);
      if (!variantes.length) return;
      var seleccion = seleccionActual(seccion);
      var variante;
      if (seleccion.length === 0) {
        variante = variantes[0];
      } else {
        variante = buscarVariante(variantes, seleccion);
      }

      var idInput = seccion.querySelector('[data-cmx-id-variante]');
      var precio = seccion.querySelector('[data-cmx-precio]');
      var antes = seccion.querySelector('[data-cmx-antes]');
      var ahorro = seccion.querySelector('[data-cmx-ahorro]');
      var stock = seccion.querySelector('[data-cmx-stock]');
      var stockTexto = seccion.querySelector('[data-cmx-stock-texto]');
      var boton = seccion.querySelector('[data-cmx-anadir]');
      var botonTexto = seccion.querySelector('[data-cmx-anadir-texto]');
      var imagen = seccion.querySelector('[data-cmx-imagen-principal]');
      var umbral = parseInt(seccion.getAttribute('data-cmx-umbral'), 10) || 5;

      if (!variante) {
        if (boton) {
          boton.setAttribute('disabled', '');
          if (botonTexto) botonTexto.textContent = seccion.getAttribute('data-cmx-txt-agotado');
        }
        if (stock) {
          stock.className = 'cmx-pp__stock cmx-pp__stock--agotado';
          if (stockTexto) stockTexto.textContent = seccion.getAttribute('data-cmx-txt-agotado');
        }
        return;
      }

      if (idInput) idInput.value = variante.id;
      if (precio) precio.textContent = variante.precio;

      if (antes) {
        if (variante.antes) {
          antes.textContent = variante.antes;
          antes.removeAttribute('hidden');
        } else {
          antes.setAttribute('hidden', '');
        }
      }

      if (ahorro) {
        if (variante.pct && variante.pct > 0) {
          ahorro.textContent = seccion.getAttribute('data-cmx-txt-ahorro') + ' ' + variante.pct + '%';
          ahorro.removeAttribute('hidden');
        } else {
          ahorro.setAttribute('hidden', '');
        }
      }

      if (boton && botonTexto) {
        if (variante.disponible) {
          boton.removeAttribute('disabled');
          botonTexto.textContent = seccion.getAttribute('data-cmx-txt-boton');
        } else {
          boton.setAttribute('disabled', '');
          botonTexto.textContent = seccion.getAttribute('data-cmx-txt-agotado');
        }
      }

      if (stock && stockTexto) {
        var clase = 'cmx-pp__stock cmx-pp__stock--hay';
        var txt = seccion.getAttribute('data-cmx-txt-hay');
        if (!variante.disponible) {
          clase = 'cmx-pp__stock cmx-pp__stock--agotado';
          txt = seccion.getAttribute('data-cmx-txt-agotado');
        } else if (variante.gestionado && variante.inventario <= umbral) {
          clase = 'cmx-pp__stock cmx-pp__stock--pocas';
          txt = seccion.getAttribute('data-cmx-txt-pocas');
        }
        stock.className = clase;
        stockTexto.textContent = txt;
      }

      if (imagen && variante.imagen) {
        imagen.src = variante.imagen;
        var minis = seccion.querySelectorAll('[data-cmx-miniatura]');
        minis.forEach(function (m) {
          m.classList.toggle('cmx-pp__miniatura--activa', m.getAttribute('data-cmx-imagen-url') === variante.imagen);
        });
      }
    }

    document.addEventListener('click', function (evento) {
      var valor = evento.target.closest('[data-cmx-valor]');
      if (valor) {
        var grupo = valor.closest('[data-cmx-opcion-grupo]');
        if (grupo) {
          grupo.querySelectorAll('.cmx-pp__valor').forEach(function (b) {
            b.classList.remove('cmx-pp__valor--activo');
          });
          valor.classList.add('cmx-pp__valor--activo');
          actualizar(valor.closest('[data-cmx-pp]'));
        }
        return;
      }

      var comprarAhora = evento.target.closest('[data-cmx-comprar-ahora]');
      if (comprarAhora) {
        evento.preventDefault();
        if (comprarAhora.hasAttribute('disabled')) return;
        var seccionCompra = comprarAhora.closest('[data-cmx-pp]');
        var formCompra = seccionCompra.querySelector('[data-cmx-form]');
        if (!formCompra) return;
        var idVar = formCompra.querySelector('[data-cmx-id-variante]');
        var cantVar = formCompra.querySelector('[data-cmx-cantidad]');
        var idValor = idVar ? idVar.value : null;
        var cantValor = cantVar ? (parseInt(cantVar.value, 10) || 1) : 1;
        if (!idValor) return;
        comprarAhora.setAttribute('disabled', '');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: idValor, quantity: cantValor })
        }).then(function (r) {
          return r.json();
        }).then(function () {
          window.location.href = '/checkout';
        }).catch(function () {
          comprarAhora.removeAttribute('disabled');
        });
        return;
      }

      var menos = evento.target.closest('[data-cmx-menos]');
      if (menos) {
        var campoMenos = menos.closest('[data-cmx-cantidad-caja]').querySelector('[data-cmx-cantidad]');
        var valMenos = parseInt(campoMenos.value, 10) || 1;
        if (valMenos > 1) campoMenos.value = valMenos - 1;
        return;
      }

      var mas = evento.target.closest('[data-cmx-mas]');
      if (mas) {
        var campoMas = mas.closest('[data-cmx-cantidad-caja]').querySelector('[data-cmx-cantidad]');
        var valMas = parseInt(campoMas.value, 10) || 1;
        campoMas.value = valMas + 1;
        return;
      }

      var faq = evento.target.closest('[data-cmx-faq]');
      if (faq) {
        var abierto = faq.getAttribute('aria-expanded') === 'true';
        faq.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        var respuesta = faq.nextElementSibling;
        if (respuesta) {
          if (abierto) {
            respuesta.setAttribute('hidden', '');
          } else {
            respuesta.removeAttribute('hidden');
          }
        }
        return;
      }

      var abrirZoom = evento.target.closest('[data-cmx-zoom-abrir]');
      if (abrirZoom) {
        var seccionZoom = abrirZoom.closest('[data-cmx-pp]');
        var zoom = seccionZoom.querySelector('[data-cmx-zoom]');
        var zoomImg = seccionZoom.querySelector('[data-cmx-zoom-img]');
        var principal = seccionZoom.querySelector('[data-cmx-imagen-principal]');
        if (zoom && zoomImg && principal) {
          zoomImg.src = principal.src;
          zoom.classList.add('cmx-pp__zoom--abierto');
          zoom.setAttribute('aria-hidden', 'false');
        }
        return;
      }

      var cerrarZoom = evento.target.closest('[data-cmx-zoom-cerrar]');
      var fondoZoom = evento.target.closest('[data-cmx-zoom]');
      if (cerrarZoom || (fondoZoom && evento.target === fondoZoom)) {
        var caja = (cerrarZoom || fondoZoom).closest('[data-cmx-zoom]');
        if (caja) {
          caja.classList.remove('cmx-pp__zoom--abierto');
          caja.setAttribute('aria-hidden', 'true');
        }
        return;
      }
    });

    document.addEventListener('click', function (evento) {
      var mini = evento.target.closest('[data-cmx-miniatura]');
      if (!mini) return;
      var seccion = mini.closest('[data-cmx-pp]');
      var principal = seccion.querySelector('[data-cmx-imagen-principal]');
      var url = mini.getAttribute('data-cmx-imagen-url');
      if (principal && url) principal.src = url;
      seccion.querySelectorAll('[data-cmx-miniatura]').forEach(function (m) {
        m.classList.remove('cmx-pp__miniatura--activa');
      });
      mini.classList.add('cmx-pp__miniatura--activa');
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key !== 'Escape') return;
      document.querySelectorAll('.cmx-pp__zoom--abierto').forEach(function (z) {
        z.classList.remove('cmx-pp__zoom--abierto');
        z.setAttribute('aria-hidden', 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productopreventa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefijo = 'cmx-ppv';

    function obtenerVariantes(seccion) {
      var nodo = seccion.querySelector('[data-cmx-variantes]');
      if (!nodo) return [];
      try {
        return JSON.parse(nodo.textContent);
      } catch (e) {
        return [];
      }
    }

    function seleccionActual(seccion) {
      var grupos = seccion.querySelectorAll('[data-cmx-opcion-grupo]');
      var valores = [];
      grupos.forEach(function (grupo) {
        var activo = grupo.querySelector('.cmx-ppv__valor--activo');
        valores.push(activo ? activo.getAttribute('data-cmx-valor-nombre') : null);
      });
      return valores;
    }

    function buscarVariante(variantes, seleccion) {
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i];
        var coincide = true;
        for (var j = 0; j < seleccion.length; j++) {
          if (seleccion[j] !== v.opciones[j]) {
            coincide = false;
            break;
          }
        }
        if (coincide) return v;
      }
      return null;
    }

    function actualizar(seccion) {
      var variantes = obtenerVariantes(seccion);
      if (!variantes.length) return;
      var seleccion = seleccionActual(seccion);
      var variante;
      if (seleccion.length === 0) {
        variante = variantes[0];
      } else {
        variante = buscarVariante(variantes, seleccion);
      }

      var idInput = seccion.querySelector('[data-cmx-id-variante]');
      var precio = seccion.querySelector('[data-cmx-precio]');
      var antes = seccion.querySelector('[data-cmx-antes]');
      var ahorro = seccion.querySelector('[data-cmx-ahorro]');
      var stock = seccion.querySelector('[data-cmx-stock]');
      var stockTexto = seccion.querySelector('[data-cmx-stock-texto]');
      var boton = seccion.querySelector('[data-cmx-anadir]');
      var botonTexto = seccion.querySelector('[data-cmx-anadir-texto]');
      var imagen = seccion.querySelector('[data-cmx-imagen-principal]');
      var umbral = parseInt(seccion.getAttribute('data-cmx-umbral'), 10) || 5;

      if (!variante) {
        if (boton) {
          boton.setAttribute('disabled', '');
          if (botonTexto) botonTexto.textContent = seccion.getAttribute('data-cmx-txt-agotado');
        }
        if (stock) {
          stock.className = 'cmx-ppv__stock cmx-ppv__stock--agotado';
          if (stockTexto) stockTexto.textContent = seccion.getAttribute('data-cmx-txt-agotado');
        }
        return;
      }

      if (idInput) idInput.value = variante.id;
      if (precio) precio.textContent = variante.precio;

      if (antes) {
        if (variante.antes) {
          antes.textContent = variante.antes;
          antes.removeAttribute('hidden');
        } else {
          antes.setAttribute('hidden', '');
        }
      }

      if (ahorro) {
        if (variante.pct && variante.pct > 0) {
          ahorro.textContent = seccion.getAttribute('data-cmx-txt-ahorro') + ' ' + variante.pct + '%';
          ahorro.removeAttribute('hidden');
        } else {
          ahorro.setAttribute('hidden', '');
        }
      }

      if (boton && botonTexto) {
        if (variante.disponible) {
          boton.removeAttribute('disabled');
          botonTexto.textContent = seccion.getAttribute('data-cmx-txt-boton');
        } else {
          boton.setAttribute('disabled', '');
          botonTexto.textContent = seccion.getAttribute('data-cmx-txt-agotado');
        }
      }

      if (stock && stockTexto) {
        var clase = 'cmx-ppv__stock cmx-ppv__stock--hay';
        var txt = seccion.getAttribute('data-cmx-txt-hay');
        if (!variante.disponible) {
          clase = 'cmx-ppv__stock cmx-ppv__stock--agotado';
          txt = seccion.getAttribute('data-cmx-txt-agotado');
        } else if (variante.gestionado && variante.inventario <= umbral) {
          clase = 'cmx-ppv__stock cmx-ppv__stock--pocas';
          txt = seccion.getAttribute('data-cmx-txt-pocas');
        }
        stock.className = clase;
        stockTexto.textContent = txt;
      }

      if (imagen && variante.imagen) {
        imagen.src = variante.imagen;
        var minis = seccion.querySelectorAll('[data-cmx-miniatura]');
        minis.forEach(function (m) {
          m.classList.toggle('cmx-ppv__miniatura--activa', m.getAttribute('data-cmx-imagen-url') === variante.imagen);
        });
      }
    }

    document.addEventListener('click', function (evento) {
      var valor = evento.target.closest('[data-cmx-valor]');
      if (valor) {
        var grupo = valor.closest('[data-cmx-opcion-grupo]');
        if (grupo) {
          grupo.querySelectorAll('.cmx-ppv__valor').forEach(function (b) {
            b.classList.remove('cmx-ppv__valor--activo');
          });
          valor.classList.add('cmx-ppv__valor--activo');
          actualizar(valor.closest('[data-cmx-ppv]'));
        }
        return;
      }

      var comprarAhora = evento.target.closest('[data-cmx-comprar-ahora]');
      if (comprarAhora) {
        evento.preventDefault();
        if (comprarAhora.hasAttribute('disabled')) return;
        var seccionCompra = comprarAhora.closest('[data-cmx-ppv]');
        var formCompra = seccionCompra.querySelector('[data-cmx-form]');
        if (!formCompra) return;
        var idVar = formCompra.querySelector('[data-cmx-id-variante]');
        var cantVar = formCompra.querySelector('[data-cmx-cantidad]');
        var idValor = idVar ? idVar.value : null;
        var cantValor = cantVar ? (parseInt(cantVar.value, 10) || 1) : 1;
        if (!idValor) return;
        comprarAhora.setAttribute('disabled', '');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: idValor, quantity: cantValor })
        }).then(function (r) {
          return r.json();
        }).then(function () {
          window.location.href = '/checkout';
        }).catch(function () {
          comprarAhora.removeAttribute('disabled');
        });
        return;
      }

      var menos = evento.target.closest('[data-cmx-menos]');
      if (menos) {
        var campoMenos = menos.closest('[data-cmx-cantidad-caja]').querySelector('[data-cmx-cantidad]');
        var valMenos = parseInt(campoMenos.value, 10) || 1;
        if (valMenos > 1) campoMenos.value = valMenos - 1;
        return;
      }

      var mas = evento.target.closest('[data-cmx-mas]');
      if (mas) {
        var campoMas = mas.closest('[data-cmx-cantidad-caja]').querySelector('[data-cmx-cantidad]');
        var valMas = parseInt(campoMas.value, 10) || 1;
        campoMas.value = valMas + 1;
        return;
      }

      var faq = evento.target.closest('[data-cmx-faq]');
      if (faq) {
        var abierto = faq.getAttribute('aria-expanded') === 'true';
        faq.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        var respuesta = faq.nextElementSibling;
        if (respuesta) {
          if (abierto) {
            respuesta.setAttribute('hidden', '');
          } else {
            respuesta.removeAttribute('hidden');
          }
        }
        return;
      }

      var abrirZoom = evento.target.closest('[data-cmx-zoom-abrir]');
      if (abrirZoom) {
        var seccionZoom = abrirZoom.closest('[data-cmx-ppv]');
        var zoom = seccionZoom.querySelector('[data-cmx-zoom]');
        var zoomImg = seccionZoom.querySelector('[data-cmx-zoom-img]');
        var principal = seccionZoom.querySelector('[data-cmx-imagen-principal]');
        if (zoom && zoomImg && principal) {
          zoomImg.src = principal.src;
          zoom.classList.add('cmx-ppv__zoom--abierto');
          zoom.setAttribute('aria-hidden', 'false');
        }
        return;
      }

      var cerrarZoom = evento.target.closest('[data-cmx-zoom-cerrar]');
      var fondoZoom = evento.target.closest('[data-cmx-zoom]');
      if (cerrarZoom || (fondoZoom && evento.target === fondoZoom)) {
        var caja = (cerrarZoom || fondoZoom).closest('[data-cmx-zoom]');
        if (caja) {
          caja.classList.remove('cmx-ppv__zoom--abierto');
          caja.setAttribute('aria-hidden', 'true');
        }
        return;
      }
    });

    document.addEventListener('click', function (evento) {
      var mini = evento.target.closest('[data-cmx-miniatura]');
      if (!mini) return;
      var seccion = mini.closest('[data-cmx-ppv]');
      var principal = seccion.querySelector('[data-cmx-imagen-principal]');
      var url = mini.getAttribute('data-cmx-imagen-url');
      if (principal && url) principal.src = url;
      seccion.querySelectorAll('[data-cmx-miniatura]').forEach(function (m) {
        m.classList.remove('cmx-ppv__miniatura--activa');
      });
      mini.classList.add('cmx-ppv__miniatura--activa');
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key !== 'Escape') return;
      document.querySelectorAll('.cmx-ppv__zoom--abierto').forEach(function (z) {
        z.classList.remove('cmx-ppv__zoom--abierto');
        z.setAttribute('aria-hidden', 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
